import script from "./purchasing-switching-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./purchasing-switching-modal.vue?vue&type=script&setup=true&lang=ts"

import "./purchasing-switching-modal.vue?vue&type=style&index=0&id=b088f980&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b088f980"]])

export default __exports__